interface FooterProps {
  scrollToSection: (id: string) => void;
}

export default function Footer({ scrollToSection }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1A1F2E] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img
              src="https://static.readdy.ai/image/9041450fc173856249e31fa6f138bbf1/d4dcc7683c3c12c9546c661fe2f1d1c5.png"
              alt="Avert Network Services"
              className="h-12 mb-4"
            />
            <p className="text-[#e10708] text-sm font-light mb-4">
              Protecting the Privilege. Powering the Billable Hour.
            </p>
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Strategic technology partner delivering <strong>IT services for law firms</strong>,
              comprehensive <strong>MSP services for law firms</strong>, and elite{' '}
              <strong>cybersecurity for law firms</strong> requiring the highest standards of
              security and service.
            </p>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-[#e10708] text-xs uppercase tracking-widest mb-4">Reach Us</h3>
            <div className="space-y-3">
              <a
                href="tel:+18552837848"
                className="block text-white hover:text-[#e10708] transition-colors cursor-pointer"
              >
                +1 (855) 283-7848
              </a>
              <a
                href="mailto:legal@avertnetworkservices.com"
                className="block text-white hover:text-[#e10708] transition-colors cursor-pointer"
              >
                legal@avertnetworkservices.com
              </a>
            </div>

            <h3 className="text-[#e10708] text-xs uppercase tracking-widest mt-8 mb-4">Headquarters</h3>
            <p className="text-white/60 text-sm leading-relaxed">
              Irving, TX<br />
              San Antonio, TX
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6">Services</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('solutions')}
                  className="text-white/70 hover:text-[#e10708] transition-colors text-sm cursor-pointer"
                >
                  IT Support
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('solutions')}
                  className="text-white/70 hover:text-[#e10708] transition-colors text-sm cursor-pointer"
                >
                  Cybersecurity
                </button>
              </li>
              <li>
                <a 
                  href="/texas-sb-2610"
                  className="text-white/70 hover:text-[#e10708] transition-colors text-sm cursor-pointer"
                >
                  SB 2610 Compliance
                </a>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('solutions')}
                  className="text-white/70 hover:text-[#e10708] transition-colors text-sm cursor-pointer"
                >
                  Cloud Solutions
                </button>
              </li>
            </ul>
          </div>

          {/* Practice Areas Column */}
          <div>
            <h3 className="text-[#e10708] text-xs uppercase tracking-widest mb-4">
              Practice Areas We Serve
            </h3>
            <ul className="space-y-3 text-white/60 text-sm">
              <li>Mergers &amp; Acquisitions</li>
              <li>Litigation</li>
              <li>Personal Injury</li>
              <li>Corporate Law</li>
              <li>Real Estate</li>
              <li>Family Law</li>
              <li>Criminal Defense</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#e10708]/30">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-sm">
              © {currentYear} Avert Network Services. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a
                href="#"
                className="text-white/60 hover:text-[#e10708] text-sm transition-colors cursor-pointer"
              >
                Privacy Policy
              </a>
              <span className="text-[#e10708]">|</span>
              <a
                href="#"
                className="text-white/60 hover:text-[#e10708] text-sm transition-colors cursor-pointer"
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
